<template>
  <v-dialog width="150px" :value="onProgress">
    <v-card class="pa-3">
      <div class="content">
        <v-progress-circular :size="80" :width="7" :color="color" indeterminate />
      </div>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';

const props = Vue.extend({
  props: {
    color: { type: String },
  },
});

@Component
export default class ProgressDialog extends props {
  get onProgress() {
    return Store.getters.progress.onProgress;
  }
}
</script>

<style scoped>
.content {
  display: flex;
  justify-content: center;
  overflow: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.content::-webkit-scrollbar {
  display: none;
}
</style>

